<template>
<!--  <div class="navbar" style="height: 55px;">-->
<!--    <div class="navbar__bot" :class="{ 'active' : displayBottom }">-->
<!--      <div class="container">-->
<!--        <div class="navbar__bot__element text-left mr-5">-->
<!--          <router-link to="/courses" class="navbar__logo">-->
<!--            <svg width="280.52130991285907" height="50.491375415928985" viewBox="0 0 280.52130991285907 50.491375415928985" class="css-1j8o68f" style="width: 150px;">-->
<!--              <defs id="SvgjsDefs8610"></defs>-->
<!--              <g id="SvgjsG8611" featurekey="Df7oLJ-0" transform="matrix(0.9230598023856772,0,0,0.9230598023856772,1.341224216360501,-15.32279131112476)" fill="#ffffff">-->
<!--                <g xmlns="http://www.w3.org/2000/svg">-->
<!--                  <path d="M80.6,43c1.3-3.9,0.6-9.3-2.8-12.5c-3.6-3.5-9.7-4.5-14.3-2.2c-3.6-6.8-12.3-11.7-21.1-11.7c-2.3,0-4.5,0.3-6.5,1   c-9.5,3-18.4,11.7-18.1,23.1c-1-0.2-2.1-0.3-3.2-0.3c-7.2,0-13,4.9-13.8,11.7c-0.4,3.3,0.6,6.3,2.8,8.7c3.3,3.6,9.2,5.8,16,5.8   h13.8v-3.2H19.7c-5.9,0-11-1.8-13.6-4.7c-1.6-1.7-2.2-3.8-2-6.2c0.6-5.1,5-8.9,10.6-8.9c1.5,0,3,0.3,4.4,0.8l2.5,1l-0.4-2.7   c-1.5-10.7,6.7-19.2,15.7-22c1.8-0.6,3.7-0.8,5.6-0.8c8.1,0,16.4,5,18.9,11.4l0.8,2l1.7-1.2c1.6-1.1,3.3-1.7,5.2-1.7   c2.4,0,4.9,1,6.6,2.6c2.8,2.7,3,7.8,1.4,10.5l-1.3,2.2l2.5,0.3c3.9,0.4,8.1,4.7,7.8,9.9c-0.3,4.4-4.2,7.8-9.2,7.8H75v3.2h1.7   c6.7,0,12-4.6,12.4-10.8C89.5,49.6,85.2,44.5,80.6,43z"></path>-->
<!--                  <path d="M51,66.3l-15.3-7v6.9c1,1.8,8.1,4.7,15.3,5.1c7.3-0.3,14.3-3.3,15.3-5.1v-6.9L51,66.3z"></path>-->
<!--                  <path d="M51,41.4L23.2,51.6L51,64.3l27.8-12.7L51,41.4z M51,51.7c-1.3,0-2.2-1.3-2.3-1.9l0.2-0.2c0,0,0.9,0.5,2.1,0.5   c1.3,0,2.1-0.5,2.1-0.5l0.2,0.2C53.2,50.4,52.3,51.7,51,51.7z"></path>-->
<!--                  <rect x="68" y="54.6" width="1.3" height="15.5"></rect>-->
<!--                  <rect x="72.3" y="53.2" width="1.3" height="15.5"></rect>-->
<!--                  <rect x="70.2" y="53.8" width="1.3" height="17.1"></rect>-->
<!--                </g>-->
<!--              </g>-->
<!--              <g id="SvgjsG8612" featurekey="Ua4uQk-0" transform="matrix(2.730936246169782,0,0,2.730936246169782,97.35740825129018,-9.747057291971078)" fill="#ffffff">-->
<!--                <path d="M10.67 17.16 c0.18 0 0.3 0.12 0.3 0.3 l0 2.24 c0 0.18 -0.12 0.3 -0.3 0.3 l-8.67 0 c-0.18 0 -0.3 -0.12 -0.3 -0.3 l0 -13.4 c0 -0.18 0.12 -0.3 0.3 -0.3 l2.63 0 c0.18 0 0.3 0.12 0.3 0.3 l0 10.86 l5.74 0 z M28.21 6 c0.18 0 0.3 0.12 0.3 0.3 l0 13.4 c0 0.18 -0.12 0.3 -0.3 0.3 l-2.63 0 c-0.18 0 -0.3 -0.12 -0.3 -0.3 l0 -6.64 l-2.64 6.69 c-0.06 0.16 -0.2 0.25 -0.36 0.25 l-2.36 0 c-0.16 0 -0.31 -0.09 -0.37 -0.25 l-2.65 -6.72 l0 6.67 c0 0.18 -0.12 0.3 -0.3 0.3 l-2.63 0 c-0.18 0 -0.3 -0.12 -0.3 -0.3 l0 -13.4 c0 -0.18 0.12 -0.3 0.3 -0.3 l2.95 0 c0.16 0 0.3 0.06 0.36 0.2 l3.82 10.06 l3.81 -10.06 c0.06 -0.14 0.2 -0.2 0.36 -0.2 l2.94 0 z M36.4 11.53 c2.63 0.49 5.4 1.41 5.4 4.48 c0 2.99 -1.8 4.29 -5.33 4.29 c-3.29 0 -4.91 -1.12 -5.16 -3.92 c-0.02 -0.2 0.1 -0.33 0.28 -0.33 l2.41 0 c0.18 0 0.25 0.11 0.3 0.27 c0.26 0.72 0.9 1.07 2.17 1.07 c1.34 0 2.17 -0.38 2.17 -1.27 c0 -0.93 -0.3 -1.43 -2.24 -1.81 c-2.48 -0.49 -4.88 -1.52 -4.88 -4.34 c0 -2.58 1.57 -4.14 4.88 -4.14 c2.95 0 4.71 1.09 4.98 3.79 c0.02 0.2 -0.1 0.36 -0.28 0.36 l-2.23 0 c-0.18 0 -0.25 -0.14 -0.3 -0.3 c-0.19 -0.58 -0.82 -0.97 -2.12 -0.97 c-1.19 0 -1.79 0.52 -1.79 1.26 c0 0.6 -0.04 1.22 1.74 1.56 z M54.5 19.64 c0.16 0.2 0.06 0.36 -0.18 0.36 l-2.73 0 c-0.16 0 -0.27 -0.04 -0.36 -0.18 l-2.74 -3.43 l-0.87 0.95 l0 2.36 c0 0.18 -0.12 0.3 -0.3 0.3 l-2.52 0 c-0.18 0 -0.3 -0.12 -0.3 -0.3 l0 -14 c0 -0.18 0.12 -0.3 0.3 -0.3 l2.52 0 c0.18 0 0.3 0.12 0.3 0.3 l0 7.84 l2.85 -3.18 c0.1 -0.12 0.22 -0.16 0.36 -0.16 l2.92 0 c0.26 0 0.34 0.19 0.16 0.36 l-3.54 3.82 z M66.67 17.41 c0.3 0.1 0.4 0.18 0.4 0.33 l0 2.06 c0 0.25 -0.4 0.29 -0.7 0.28 c-1.54 -0.02 -2.47 -0.39 -2.47 -1.72 l-0.3 0 l0 0.04 c-0.57 0.92 -2.15 1.84 -3.63 1.84 c-2.03 0 -3.44 -1 -3.44 -2.82 c0 -1.99 1.34 -2.77 3.7 -3.13 l1.19 -0.18 c0.76 -0.12 1.34 -0.26 1.53 -0.5 c-0.11 -0.83 -0.65 -1.04 -1.35 -1.04 c-0.88 0 -1.48 0.23 -1.61 0.9 c-0.02 0.11 -0.1 0.19 -0.28 0.19 l-2.36 0 c-0.18 0 -0.33 -0.1 -0.31 -0.3 c0.26 -2.57 2.06 -3.38 4.61 -3.38 c2.7 0 4.38 1.24 4.38 4.03 l0 2.55 c0 0.36 0.18 0.7 0.64 0.85 z M59.62 16.93 c0 0.45 0.37 0.73 1.02 0.73 c0.79 0 1.59 -0.15 2.33 -0.88 l0 -1.36 c-0.18 0.28 -0.79 0.41 -1.62 0.56 l-0.84 0.16 c-0.54 0.1 -0.89 0.41 -0.89 0.79 z"></path>-->
<!--              </g>-->
<!--            </svg>-->
<!--          </router-link>-->
<!--        </div>-->

<!--        <div class="navbar__bot__element navbar__bot&#45;&#45;menu flex-grow-1" v-if="isLoggedIn">-->
<!--          <ul class="navbar__menu-list">-->
<!--            <li class="navbar__menu-item">-->
<!--              <router-link to="/courses">{{$t('menu.courses')}}</router-link>-->
<!--            </li>-->
<!--            <li class="navbar__menu-item">-->
<!--              <router-link to="/orders">{{$t('menu.orders')}}</router-link>-->
<!--            </li>-->
<!--            <li class="navbar__menu-item">-->
<!--              <router-link to="/chat">{{$t('menu.messages')}}</router-link>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </div>-->

<!--        <div class="navbar__bot__element userMenu p-0">-->
<!--          <Notification class="navbar__notification" />-->
<!--          <LangBar class="langBar" />-->
<!--          <UserBar v-if="isLoggedIn" :userData="user" @logout="handleLogout" />-->
<!--          <router-link class="text-white d-flex align-items-center" v-else to="/login">-->
<!--            <span class="font-weight-normal">{{$t('menu.cabinet')}}</span>-->
<!--            <i class="fa fa-sign-in ml-2"></i>-->
<!--          </router-link>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="navbar__bot navbar__bot&#45;&#45;mobile" v-if="isLoggedIn">-->
<!--      <div class="container">-->
<!--        <ul class="navbar__menu-list">-->
<!--          <li class="navbar__menu-item">-->
<!--            <router-link to="/courses">{{$t('menu.courses')}}</router-link>-->
<!--          </li>-->
<!--          <li class="navbar__menu-item">-->
<!--            <router-link to="/orders">{{$t('menu.orders')}}</router-link>-->
<!--          </li>-->
<!--          <li class="navbar__menu-item">-->
<!--            <router-link to="/chat">{{$t('menu.messages')}}</router-link>-->
<!--          </li>-->
<!--        </ul>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
  
  <div class="topNavBar">
    <div id="kt_header" class="kt-header kt-grid__item kt-header--fixed">
      <div class="container">
        <div class="kt-header__topbar d-flex align-items-center w-100">
          <div class="kt-header__topbar-item mr-auto">
            <router-link to="/courses" class="navbar__logo">
              <svg width="280.52130991285907" height="50.491375415928985" viewBox="0 0 280.52130991285907 50.491375415928985" class="css-1j8o68f" style="width: 120px;">
                <defs id="SvgjsDefs8610"></defs>
                <g id="SvgjsG8611" featurekey="Df7oLJ-0" transform="matrix(0.9230598023856772,0,0,0.9230598023856772,1.341224216360501,-15.32279131112476)" fill="#ffffff">
                  <g xmlns="http://www.w3.org/2000/svg">
                    <path d="M80.6,43c1.3-3.9,0.6-9.3-2.8-12.5c-3.6-3.5-9.7-4.5-14.3-2.2c-3.6-6.8-12.3-11.7-21.1-11.7c-2.3,0-4.5,0.3-6.5,1   c-9.5,3-18.4,11.7-18.1,23.1c-1-0.2-2.1-0.3-3.2-0.3c-7.2,0-13,4.9-13.8,11.7c-0.4,3.3,0.6,6.3,2.8,8.7c3.3,3.6,9.2,5.8,16,5.8   h13.8v-3.2H19.7c-5.9,0-11-1.8-13.6-4.7c-1.6-1.7-2.2-3.8-2-6.2c0.6-5.1,5-8.9,10.6-8.9c1.5,0,3,0.3,4.4,0.8l2.5,1l-0.4-2.7   c-1.5-10.7,6.7-19.2,15.7-22c1.8-0.6,3.7-0.8,5.6-0.8c8.1,0,16.4,5,18.9,11.4l0.8,2l1.7-1.2c1.6-1.1,3.3-1.7,5.2-1.7   c2.4,0,4.9,1,6.6,2.6c2.8,2.7,3,7.8,1.4,10.5l-1.3,2.2l2.5,0.3c3.9,0.4,8.1,4.7,7.8,9.9c-0.3,4.4-4.2,7.8-9.2,7.8H75v3.2h1.7   c6.7,0,12-4.6,12.4-10.8C89.5,49.6,85.2,44.5,80.6,43z"></path>
                    <path d="M51,66.3l-15.3-7v6.9c1,1.8,8.1,4.7,15.3,5.1c7.3-0.3,14.3-3.3,15.3-5.1v-6.9L51,66.3z"></path>
                    <path d="M51,41.4L23.2,51.6L51,64.3l27.8-12.7L51,41.4z M51,51.7c-1.3,0-2.2-1.3-2.3-1.9l0.2-0.2c0,0,0.9,0.5,2.1,0.5   c1.3,0,2.1-0.5,2.1-0.5l0.2,0.2C53.2,50.4,52.3,51.7,51,51.7z"></path>
                    <rect x="68" y="54.6" width="1.3" height="15.5"></rect>
                    <rect x="72.3" y="53.2" width="1.3" height="15.5"></rect>
                    <rect x="70.2" y="53.8" width="1.3" height="17.1"></rect>
                  </g>
                </g>
                <g id="SvgjsG8612" featurekey="Ua4uQk-0" transform="matrix(2.730936246169782,0,0,2.730936246169782,97.35740825129018,-9.747057291971078)" fill="#ffffff">
                  <path d="M10.67 17.16 c0.18 0 0.3 0.12 0.3 0.3 l0 2.24 c0 0.18 -0.12 0.3 -0.3 0.3 l-8.67 0 c-0.18 0 -0.3 -0.12 -0.3 -0.3 l0 -13.4 c0 -0.18 0.12 -0.3 0.3 -0.3 l2.63 0 c0.18 0 0.3 0.12 0.3 0.3 l0 10.86 l5.74 0 z M28.21 6 c0.18 0 0.3 0.12 0.3 0.3 l0 13.4 c0 0.18 -0.12 0.3 -0.3 0.3 l-2.63 0 c-0.18 0 -0.3 -0.12 -0.3 -0.3 l0 -6.64 l-2.64 6.69 c-0.06 0.16 -0.2 0.25 -0.36 0.25 l-2.36 0 c-0.16 0 -0.31 -0.09 -0.37 -0.25 l-2.65 -6.72 l0 6.67 c0 0.18 -0.12 0.3 -0.3 0.3 l-2.63 0 c-0.18 0 -0.3 -0.12 -0.3 -0.3 l0 -13.4 c0 -0.18 0.12 -0.3 0.3 -0.3 l2.95 0 c0.16 0 0.3 0.06 0.36 0.2 l3.82 10.06 l3.81 -10.06 c0.06 -0.14 0.2 -0.2 0.36 -0.2 l2.94 0 z M36.4 11.53 c2.63 0.49 5.4 1.41 5.4 4.48 c0 2.99 -1.8 4.29 -5.33 4.29 c-3.29 0 -4.91 -1.12 -5.16 -3.92 c-0.02 -0.2 0.1 -0.33 0.28 -0.33 l2.41 0 c0.18 0 0.25 0.11 0.3 0.27 c0.26 0.72 0.9 1.07 2.17 1.07 c1.34 0 2.17 -0.38 2.17 -1.27 c0 -0.93 -0.3 -1.43 -2.24 -1.81 c-2.48 -0.49 -4.88 -1.52 -4.88 -4.34 c0 -2.58 1.57 -4.14 4.88 -4.14 c2.95 0 4.71 1.09 4.98 3.79 c0.02 0.2 -0.1 0.36 -0.28 0.36 l-2.23 0 c-0.18 0 -0.25 -0.14 -0.3 -0.3 c-0.19 -0.58 -0.82 -0.97 -2.12 -0.97 c-1.19 0 -1.79 0.52 -1.79 1.26 c0 0.6 -0.04 1.22 1.74 1.56 z M54.5 19.64 c0.16 0.2 0.06 0.36 -0.18 0.36 l-2.73 0 c-0.16 0 -0.27 -0.04 -0.36 -0.18 l-2.74 -3.43 l-0.87 0.95 l0 2.36 c0 0.18 -0.12 0.3 -0.3 0.3 l-2.52 0 c-0.18 0 -0.3 -0.12 -0.3 -0.3 l0 -14 c0 -0.18 0.12 -0.3 0.3 -0.3 l2.52 0 c0.18 0 0.3 0.12 0.3 0.3 l0 7.84 l2.85 -3.18 c0.1 -0.12 0.22 -0.16 0.36 -0.16 l2.92 0 c0.26 0 0.34 0.19 0.16 0.36 l-3.54 3.82 z M66.67 17.41 c0.3 0.1 0.4 0.18 0.4 0.33 l0 2.06 c0 0.25 -0.4 0.29 -0.7 0.28 c-1.54 -0.02 -2.47 -0.39 -2.47 -1.72 l-0.3 0 l0 0.04 c-0.57 0.92 -2.15 1.84 -3.63 1.84 c-2.03 0 -3.44 -1 -3.44 -2.82 c0 -1.99 1.34 -2.77 3.7 -3.13 l1.19 -0.18 c0.76 -0.12 1.34 -0.26 1.53 -0.5 c-0.11 -0.83 -0.65 -1.04 -1.35 -1.04 c-0.88 0 -1.48 0.23 -1.61 0.9 c-0.02 0.11 -0.1 0.19 -0.28 0.19 l-2.36 0 c-0.18 0 -0.33 -0.1 -0.31 -0.3 c0.26 -2.57 2.06 -3.38 4.61 -3.38 c2.7 0 4.38 1.24 4.38 4.03 l0 2.55 c0 0.36 0.18 0.7 0.64 0.85 z M59.62 16.93 c0 0.45 0.37 0.73 1.02 0.73 c0.79 0 1.59 -0.15 2.33 -0.88 l0 -1.36 c-0.18 0.28 -0.79 0.41 -1.62 0.56 l-0.84 0.16 c-0.54 0.1 -0.89 0.41 -0.89 0.79 z"></path>
                </g>
              </svg>
            </router-link>
          </div>
          <div class="navbar__bot__element navbar__bot--menu flex-grow-1" v-if="isLoggedIn">
            <ul class="navbar__menu-list">
              <li class="navbar__menu-item">
                <router-link to="/courses">{{$t('menu.courses')}}</router-link>
              </li>
              <li class="navbar__menu-item">
                <router-link to="/orders">{{$t('menu.orders')}}</router-link>
              </li>
              <li class="navbar__menu-item">
                <router-link to="/chat">{{$t('menu.messages')}}</router-link>
              </li>
            </ul>
          </div>
          <div class="kt-header__topbar-item px-2" v-if="$route.name !== 'AddOrderWithHash' && $route.name !== 'AddOrder'">
            <div class="kt-header__topbar-wrapper">
              <div class="kt-switch kt-switch--dark kt-switch--sm d-flex align-items-center"
                   :class="{'kt-switch--outline': theme==='light'}">
                <span class="mr-1">☀️</span>
                <label class="mb-0">
                  <input type="checkbox" v-model="isDarkTheme" @change="changeTheme">
                  <span></span>
                </label>
                <span class="ml-1">🌙</span>
              </div>
            </div>
          </div>
          <div class="kt-header__topbar-item" v-if="isLoggedIn">
            <div class="kt-header__topbar-wrapper">
              <Notification class="navbar__notification" />
            </div>
          </div>
          <div class="kt-header__topbar-item">
            <div class="kt-header__topbar-wrapper">
              <LangBar class="langBar"/>
            </div>
          </div>
          <UserBar v-if="isLoggedIn" :userData="user" :loading="loading" @logout="handleLogout"></UserBar>
        </div>
      </div>
    </div>
    <div class="navbar__bot navbar__bot--mobile" v-if="isLoggedIn">
      <div class="container">
        <ul class="navbar__menu-list">
          <li class="navbar__menu-item">
            <router-link to="/courses">{{$t('menu.courses')}}</router-link>
          </li>
          <li class="navbar__menu-item">
            <router-link to="/orders">{{$t('menu.orders')}}</router-link>
          </li>
          <li class="navbar__menu-item">
            <router-link to="/chat">{{$t('menu.messages')}}</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {logout} from "@/services/customer/auth/auth"
import LangBar from "@/components/general/LangBar"
import UserBar from "@/components/general/UserBar.vue"
import Notification from "@/components/general/Notification.vue";
import logoWhite from '@/assets/l-white.svg'
import logoBlack from '@/assets/l-black.svg'

export default {
  name: "NavBar",
  props: ['short'],
  components: {
    LangBar,
    UserBar,
    Notification
  },
  data () {
    return {
      loading: false,
      logoBlack,
      logoWhite,
      displayBottom: false,
      navColor: {
        id: 1,
        value: ''
      },
      navTextColor: {
        id: 1,
        value: ''
      },
      isDarkTheme: false
    }
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn
    },
    getUserEmail() {
      return this.$store.getters.getUserEmail
    },
    user() {
      return this.$store.getters.getUserData
    },
    route() {
      return this.$route.name
    },
    theme() {
      return this.$store.state.theme
    }
  },
  created() {
    document.documentElement.classList.add('theme--' + this.theme)
    this.isDarkTheme = this.theme === 'dark'
    this.$bus.$on('changeFormColor', (data) => this.navColor = data)
    this.$bus.$on('changeTextColor', (data) => this.navTextColor = data)
  },
  methods: {
    changeTheme() {
      this.$store.dispatch('setTheme', this.theme === 'dark' ? 'light' : 'dark')
    },
    checkLogo() {
      return this.$route.path === 'add-order'
    },
    handleLogout() {
      logout().then(() => {
        this.$router.push('/login')
      }).catch(() => {})
    },
    gotToLogin () {
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="sass" scoped>
.kt-header
  background: var(--bs-primary)
  border: 0
  .kt-header__topbar
    height: 65px
    .kt-header__topbar-item
      &:hover
        .kt-header__topbar-icon
          i
            color: var(--bs-white)
</style>

<style lang="scss">
$primary-bg: #5d78ff;
$primary: #533BAA;

.navbar__bot, .navbar__info {
  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.userMenu {
  text-align: right;
  padding-right: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .user-dropdown {
    height: 100%;
    border-radius: 0;
    background: transparent;
    .dropdown-toggle {
      height: auto;
      background: transparent !important;
      color: #fff !important;
      padding: 5px 0 5px 10px;
      border: 0;
      font-size: 1em;
      &:hover {
        opacity: .8;
      }
    }
    .dropdown-menu {
      padding: 0;
      min-width: 100% !important;
    }
    .b-dropdown-text,
    .dropdown-item {
      line-height: 1;
      padding: 15px;
      margin: 0;
      display: flex;
      align-items: center;
    }
    .dropdown-item:active {
      color: inherit;
      background: transparent;
    }
    .dropdown-divider {
      margin: 0;
    }
  }
}
.navbar {
  width: 100%;
  height: 95px;
  color: #fff;
  z-index: 10;
  display: flex;
  flex-direction: column;
  padding: 0 !important;
  text-align: center;
  background: $primary-bg;
  position: fixed;
  top: 0;
}
.navbar__bot {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
  line-height: 55px;
}
.navbar__bot--mobile {
  display: none;
  position: absolute;
  top: 65px;
  left: 0;
  right: 0;
  height: auto;
  background: var(--bs-white);
  color: var(--bs-dark);
  padding: 0 1rem;
  .theme--dark & {
    background: var(--bs-gray-200);
  }
  .navbar__menu-item a {
    color: var(--bs-dark);
  }
}
.navbar__info,.navbar__info--mobile {
  display: flex;
  background: #fff;
  height: 40px;
  width: 100%;
  box-shadow: 0 4px 20px rgba(0,0,0,.04)
}
.navbar__info--mobile {
  display: none;
  .dropdown {
    width: 100%;
    height: 100%;
    .dropdown-toggle {
      border: 0;
      color: #000 !important;
      font-size: 14px;
      background: #fff;
      &:hover, &:focus, &:active {
        background: transparent;
      }
      &::after {
        content: '';
        display: inline-block;
        font-size: 14px;
        border-top: .3em solid;
        border-right: .3em solid transparent;
        border-bottom: 0;
        border-left: .3em solid transparent;
      }
    }
    .dropdown-menu {
      right: 0;
      margin: 0px -10px;
      padding: 1rem 10px;
      font-size: 14px;
      .b-dropdown-text {
        padding: 0 1.2rem;
      }
    }
  }
}
.navbar__info-text {
  color: #000;
  width: 33%;
  a[href] {
    color: inherit;
    &:hover {
      text-decoration: none;
      color: $primary;
    }
  }
}
.navbar__bot__element {
  //width: 20%;
  color: inherit;
  height: 55px;
  display: flex;
  align-items: center;
  padding: 0 30px;
  .logo {
    padding: 7px 0;
  }
}
.navbar__logo {
  height: 100%;
  display: inline-flex;
  align-items: center;
}
.navbar__menu-list {
  list-style: none;
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}
.navbar__menu-item {
  &:not(:last-child) {
    margin-right: 25px;
  }
  a {
    color: #fff;
    font-weight: 500;
    position: relative;
    &:before {
      content: '';
      position: absolute;
      left: -10px;
      width: 7px;
      height: 7px;
      border: 1px solid #fff;
      background: transparent;
      border-radius: 50%;
      top: 50%;
      transform: translateY(-50%);
      opacity: 0;
      transition: all .2s;
    }
    &:hover {
      &:before {
        opacity: 1;
      }
    }
    &.router-link-active {
      &:before {
        background: #fff;
        opacity: 1;
      }
    }
  }
  .btn {
    color: #fff!important;
  }
}

.cabinet {
  text-align: left;
  padding-left: 10px;
}
.cabinet a{
  text-decoration: none;
  color: inherit;
}
.logo {
  object-fit: contain;
  width: 100%;
  height: 100%
}
@media screen and (max-width: 1024px) {
  .kt-header__topbar {
    background: var(--bs-primary);
    top: 0;
    margin-top: 0;
  }
}
@media screen and (max-width: 880px) {
  .navbar__info {
    display: none;
  }
  .navbar__info--mobile {
    display: flex;
  }
  .navbar__bot {
    justify-content: center!important;
  }
  .email {
    display: none
  }
  .balance {
    display: none
  }
  .cabinet-text {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .navbar__bot--menu {
    display: none;
  }
  .navbar__bot--mobile {
    display: flex;
  }
  .navbar__menu-item {
    font-size: 0.9rem;
    &:not(:last-child) {
      margin-right: 15px;
    }
  }
}
@media screen and (max-width: 550px) {
  .langBar {
    .dropdown-menu {
      left: -200% !important;
    }
  }
  .stream-email {
    a {
      font-size: 14px;
    }
  }
  .stream-logout {
    span {
      display: none;
    }
  }
}
@media screen and (max-width: 360px) {
  .navbar__logo {
    width: 95px!important; 
  }
}
</style>